(function () {
  // ✅ Ensure script loaded
  window.LSF_READY = true;

  // Helper to ensure DOM ready
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(() => {
    /* =====================================================
       RANGE → OUTPUT BINDING
    ===================================================== */
    document.querySelectorAll('input[type="range"][data-output]').forEach((range) => {
      const out = document.querySelector(range.getAttribute("data-output"));
      if (!out) return;

      const update = () => {
        out.textContent = range.value;
      };

      update();
      range.addEventListener("input", update);
      range.addEventListener("change", update);
    });

    /* =====================================================
       MODAL CONTROL
    ===================================================== */
    const modal = document.getElementById("ls-filter-modal");
    const openBtn = document.getElementById("ls-open-filter");
    const closeBtn = document.getElementById("ls-close-filter");
    let modalTrigger = null;

    function openFilterModal() {
      if (!modal) return;
      modalTrigger = document.activeElement;
      modal.removeAttribute("hidden");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      closeBtn?.focus();
    }

    function closeFilterModal() {
      if (!modal) return;
      modal.setAttribute("hidden", "");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (modalTrigger instanceof HTMLElement) modalTrigger.focus();
    }

    if (openBtn && modal) {
      openBtn.addEventListener("click", openFilterModal);
    }

    if (closeBtn && modal) {
      closeBtn.addEventListener("click", closeFilterModal);
    }

    if (modal) {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) closeFilterModal();
      });

      modal.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          closeFilterModal();
          return;
        }

        if (e.key !== "Tab") return;

        const focusable = modal.querySelectorAll(
          'button, input, select, textarea, [href], [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    /* =====================================================
       SHOW / HIDE HELPERS
    ===================================================== */
    const show = (el) => {
      el.style.display = "";
      el.style.opacity = "1";
    };

    const hide = (el) => {
      el.style.opacity = "0";
      setTimeout(() => {
        el.style.display = "none";
      }, 200);
    };

    /* =====================================================
       DILDO / BUTT PLUG FILTER LOGIC
       Uses product.metafields.specs.size_matrix
       JSON keys accepted:
       - usable_length
       - usable_length_cm
       - max_diameter
       - shaft_diameter_cm
    ===================================================== */
    const sizeForm = document.querySelector("#ls-filter-form.ls-dildo, #ls-filter-form.ls-buttplug");

    if (sizeForm) {

      const ulMin = document.getElementById("ls-ul-min");
      const ulMax = document.getElementById("ls-ul-max");
      const sdMin = document.getElementById("ls-sd-min");
      const sdMax = document.getElementById("ls-sd-max");

      const ulOutMin =
        document.getElementById("ls-ul-min-out") ||
        document.getElementById("ls-ul-out-min");

      const ulOutMax =
        document.getElementById("ls-ul-max-out") ||
        document.getElementById("ls-ul-out-max");

      const sdOutMin =
        document.getElementById("ls-sd-min-out") ||
        document.getElementById("ls-sd-out-min");

      const sdOutMax =
        document.getElementById("ls-sd-max-out") ||
        document.getElementById("ls-sd-out-max");

      const defaults = {
        ulMin: parseFloat(sizeForm.dataset.ulMinDefault || ulMin?.value || 8),
        ulMax: parseFloat(sizeForm.dataset.ulMaxDefault || ulMax?.value || 40),
        sdMin: parseFloat(sizeForm.dataset.sdMinDefault || sdMin?.value || 2),
        sdMax: parseFloat(sizeForm.dataset.sdMaxDefault || sdMax?.value || 8)
      };

      function updateOutputs() {
        if (ulOutMin && ulMin) ulOutMin.textContent = ulMin.value;
        if (ulOutMax && ulMax) ulOutMax.textContent = ulMax.value;
        if (sdOutMin && sdMin) sdOutMin.textContent = sdMin.value;
        if (sdOutMax && sdMax) sdOutMax.textContent = sdMax.value;
      }

      function clampRanges() {
        if (!ulMin || !ulMax || !sdMin || !sdMax) return;

        if (parseFloat(ulMin.value) > parseFloat(ulMax.value) - 1) {
          ulMin.value = parseFloat(ulMax.value) - 1;
        }

        if (parseFloat(ulMax.value) < parseFloat(ulMin.value) + 1) {
          ulMax.value = parseFloat(ulMin.value) + 1;
        }

        if (parseFloat(sdMin.value) > parseFloat(sdMax.value) - 0.3) {
          sdMin.value = (parseFloat(sdMax.value) - 0.3).toFixed(1);
        }

        if (parseFloat(sdMax.value) < parseFloat(sdMin.value) + 0.3) {
          sdMax.value = (parseFloat(sdMin.value) + 0.3).toFixed(1);
        }

        updateOutputs();
      }

      [ulMin, ulMax, sdMin, sdMax].forEach((slider) => {
        slider?.addEventListener("input", clampRanges);
        slider?.addEventListener("change", clampRanges);
      });

      sizeForm.addEventListener("submit", (e) => {
        e.preventDefault();

        const ulMinVal = parseFloat(ulMin?.value || 0);
        const ulMaxVal = parseFloat(ulMax?.value || 0);
        const sdMinVal = parseFloat(sdMin?.value || 0);
        const sdMaxVal = parseFloat(sdMax?.value || 0);

        document.querySelectorAll(".grid__item[data-product-id]").forEach((item) => {
          const pid = item.dataset.productId;
          const jsonEl = document.querySelector(`.ls-size-matrix[data-product-id="${pid}"]`);

          if (!jsonEl) return;

          let data = [];

          try {
            data = JSON.parse(jsonEl.textContent.trim() || "[]");
          } catch (error) {
            data = [];
          }

          const match = data.some((d) => {
            const len = parseFloat(d.usable_length || d.usable_length_cm || 0);
            const dia = parseFloat(d.max_diameter || d.shaft_diameter_cm || 0);

            return (
              len >= ulMinVal &&
              len <= ulMaxVal &&
              dia >= sdMinVal &&
              dia <= sdMaxVal
            );
          });

          item.style.display = match ? "" : "none";
        });

        closeFilterModal();
      });

      document.getElementById("ls-reset")?.addEventListener("click", () => {
        document.querySelectorAll(".grid__item[data-product-id]").forEach((item) => {
          item.style.display = "";
          item.style.opacity = "1";
        });

        if (ulMin) ulMin.value = defaults.ulMin;
        if (ulMax) ulMax.value = defaults.ulMax;
        if (sdMin) sdMin.value = defaults.sdMin;
        if (sdMax) sdMax.value = defaults.sdMax;

        updateOutputs();
      });

      updateOutputs();
    }

    /* =====================================================
       MASTURBATOR FILTER LOGIC
       Diameter or circumference, cm or inch
       JSON stores ONLY canal circumference in cm
    ===================================================== */
    const mastForm = document.querySelector("#ls-filter-form.ls-masturbator");

    if (mastForm) {

      const sizeInput = document.getElementById("ls-size-value");
      const normalizedOut = document.getElementById("ls-size-normalized-out");

      const getMeasureType = () =>
        document.querySelector('input[name="ls-measure-type"]:checked')?.value || "circumference";

      const getMeasureUnit = () =>
        document.querySelector('input[name="ls-measure-unit"]:checked')?.value || "cm";

      function toCircumferenceCm(rawValue, type, unit) {
        let valueInCm = parseFloat(rawValue || 0);

        if (unit === "in") {
          valueInCm = valueInCm * 2.54;
        }

        if (type === "diameter") {
          return valueInCm * Math.PI;
        }

        return valueInCm;
      }

      function updateNormalizedOutput() {
        const rawValue = parseFloat(sizeInput?.value || 0);
        const type = getMeasureType();
        const unit = getMeasureUnit();

        const circumferenceCm = toCircumferenceCm(rawValue, type, unit);

        if (normalizedOut) {
          normalizedOut.textContent = circumferenceCm > 0 ? circumferenceCm.toFixed(1) : "0.0";
        }
      }

      sizeInput?.addEventListener("input", updateNormalizedOutput);

      document.querySelectorAll('input[name="ls-measure-type"], input[name="ls-measure-unit"]').forEach((input) => {
        input.addEventListener("change", updateNormalizedOutput);
      });

      mastForm.addEventListener("submit", (e) => {
        e.preventDefault();

        const rawValue = parseFloat(sizeInput?.value || 0);
        const type = getMeasureType();
        const unit = getMeasureUnit();

        const penisCircumferenceCm = toCircumferenceCm(rawValue, type, unit);

        document.querySelectorAll(".grid__item[data-product-id]").forEach((card) => {
          const pid = card.getAttribute("data-product-id");
          const jsonEl = document.querySelector(`.ls-masturbator-matrix[data-product-id="${pid}"]`);

          if (!jsonEl) return;

          let data = [];

          try {
            data = JSON.parse(jsonEl.textContent.trim() || "[]");
          } catch (error) {
            data = [];
          }

          const match = data.some((row) => {
            const toyCirc = parseFloat(
              row.canal_circumference_cm ??
              row.canal_circumference ??
              row.circumference_cm ??
              row.circumference ??
              0
            );

            return toyCirc >= penisCircumferenceCm;
          });

          (match ? show : hide)(card);
        });

        closeFilterModal();
      });

      document.getElementById("ls-reset")?.addEventListener("click", () => {
        document.querySelectorAll(".grid__item[data-product-id]").forEach(show);

        const defaultType = document.querySelector('input[name="ls-measure-type"][value="circumference"]');
        const defaultUnit = document.querySelector('input[name="ls-measure-unit"][value="cm"]');

        if (defaultType) defaultType.checked = true;
        if (defaultUnit) defaultUnit.checked = true;
        if (sizeInput) sizeInput.value = "12";

        updateNormalizedOutput();
      });

      updateNormalizedOutput();
    }

    // ✅ Optional: make "Find your fit" button pulse to draw attention
    document.querySelector(".ls-fab")?.classList.add("attention");
  });
})();
